if($('.type-detail').length){
    $(".availability-value .availability-label").each(function() {
        $(this).html(function(){
          return $(this).html().replace("Zvolte variantu", "Dle varianty");
        })
    })
    $('.delivery-time').each(function() {
        $(this).html(function(){
          return $(this).html().replace("Zvolte variantu", "Dle varianty");
        })
    });
 /*   if($('.p-final-price-wrapper .price-measure').text().trim().length>3){
        if($('.variant-list').length){
            var resultHtml = '';
            $('.p-final-price-wrapper .price-measure span.choose-variant').each(function () {
                var priceMeasureText = $(this).text().trim();
                if (priceMeasureText.includes('/')) {
                    var parts = priceMeasureText.split('/');
                    var priceMeasure = parseFloat(parts[0].replace(',', '.').replace(/[^0-9.]/g, ''));
                    var unit = parts[1].match(/[a-zA-Z]+/g)?.[0] || '';
                    var priceFinalText = $(this).closest('.p-final-price-wrapper').find(`.price-final-holder.choose-variant:eq(${$(this).index()})`).text().trim();
                    var fullPrice = parseFloat(priceFinalText.replace(',', '.').replace(/[^0-9.]/g, ''));
                    if (!isNaN(fullPrice) && !isNaN(priceMeasure)) {
                        var priceForVolume = Math.ceil(fullPrice / priceMeasure);
                        resultHtml += `<span class="${$(this).attr('class')}"> ${Number(priceForVolume)} ${unit}</span>`;
                    }
                }
            });

            if($('.p-detail-inner-header h1 .product-appendix').length){
                $('.p-detail-inner-header h1 .product-appendix').before('<span class="volumeText">'+resultHtml+'</span>')
            }
            else{
                $('.p-detail-inner-header h1').append('<span class="volumeText">'+resultHtml+'</span>')
            }

           
        }
        else{
            var priceMeasure = parseFloat($('.p-final-price-wrapper .price-measure').text().trim().split('/')[0].replace(',', '.'))
            var fullPrice = parseFloat($('.p-final-price-wrapper .price-final').text().trim().replace(',', '.'))
            var priceForVolume = Math.ceil(fullPrice/priceMeasure)
            var volume = $('.p-final-price-wrapper .price-measure').text().trim().split('/')[1].match(/[a-zA-Z]+/g)?.[0] || ''
            if($('.p-detail-inner-header h1 .product-appendix').length){
                $('.p-detail-inner-header h1 .product-appendix').before('<span class="priceForVolume">'+Number(priceForVolume)+' '+volume+'</span>')
            }
            else{
                $('.p-detail-inner-header h1').append('<span class="priceForVolume">'+Number(priceForVolume)+' '+volume+'</span>')
            }
            
        }
       
    }*/

    $('.p-info-wrapper').append($('.p-detail .p-detail-inner-header').clone())
    $('.p-info-wrapper').append($('.product-top .p-detail-info .stars-wrapper').clone())
    $('.p-image').append($('.p-detail-info .flags').clone())
    $('.p-info-wrapper .add-to-cart').append('<span class="btn_toggle"></span>')
    $('.p-info-wrapper').append('<span class="btn_toggle underCart"><span class="text">Přidat do oblíbených</span></span>')
    $('.p-info-wrapper').append('<div class="availRow"></div><div class="customCart"></div>');
    if($('.delivery-time').length){
        $('.delivery-time').closest('tr').hide();
        $('.availRow').append('<div class="deliveryDate">Můžeme doručit do: <strong>'+$('.delivery-time').html()+'</strong></div>')
        $('.availRow').append($('.delivery-time').closest('tr').find('.shipping-options'))
    }
    $('.availRow').append($('.availability-value'))
    $('.customCart').append($('.p-info-wrapper>.p-final-price-wrapper'))
    $('.customCart').append($('.p-info-wrapper .add-to-cart'))

    $('p[data-testid="productCardDescr"] a').text('Celý popis')
    if($('.products-related-header').length){
        $('.products-related-header').text('Nechte se hýčkat také těmito produkty')
        $('.products-related').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: true,
            arrows: false,
            infinite: false,
            adaptiveHeight: false,
            responsive: [
    
             
             {
                breakpoint: 1199,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                 
                }
              },
               
              
              {
                breakpoint: 768,
                settings: {
                 slidesToShow: 2,
                 slidesToScroll: 2,
               }
               
              }
              
            ]
        });
           
           
           
    }
    if($('.extended-description').length){
        if($('.extended-description tr th:contains("#obsah-vyrobku")').length){
            var items = $('.extended-description table tr:contains("#obsah-vyrobku") td').text().split('|');
            $('.extended-description table tr:contains("#obsah-vyrobku")').remove()
            $('#tab-content').append('<div class="productContent"><h2>Co výrobek obsahuje?</h2><div class="productContentFeed"></div><div class="AdminproductContent"><p>Tento text vidí pouze přihlášený admin. Soubor uložte do /user/documents/upload/obrazky/detail/obsahVyrobku/ a příponu vždy .jpg</p></div></div>')
            $.each(items, function(index, value) {
                var url = urlMap[value];
                var itemsWithoutdiacritics = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '-').toLowerCase();
                var itemsImageRoad = '/user/documents/upload/obrazky/detail/obsahVyrobku/'+itemsWithoutdiacritics+'.jpg?v='+new Date().getMinutes()
                if (url) {
                    $('.productContentFeed').append('<div class="inner"><a href="' + url + '" class="positionAbsolute"></a><div class="image"><img src="'+itemsImageRoad+'" alt="'+value+'"></div><span class="title">' + value + '</span></a></div>');
                } else {
                    $('.productContentFeed').append('<div class="inner"><div class="image"><img src="'+itemsImageRoad+'" alt="'+value+'"></div><span class="title">' + value + '</span></div>');
                }

                if($('.admin-logged').length){
                    $('.AdminproductContent').append('<div class="feature">Jméno vlastnosti: '+value+'<br>Název souboru: '+itemsWithoutdiacritics.toLowerCase()+'</div>')
                }
            });
            $('.productContentFeed').slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                centerMode: false,
                autoplay: false,
                autoplaySpeed: 5000,
                dots: true,
                arrows: false,
                infinite: false,
                adaptiveHeight: false,
                responsive: [
                 {
                   breakpoint: 1439,
                   settings: {
                     slidesToShow: 6,
                     slidesToScroll: 1,
                    
                   }
                 },
                 {
                    breakpoint: 1199,
                    settings: {
                      slidesToShow: 5,
                      slidesToScroll: 1,
                     
                    }
                  },
                  {
                    breakpoint: 991,
                    settings: {
                     slidesToShow: 4,
                     slidesToScroll: 1,
                     
                   }
                   
                  },
                  {
                    breakpoint: 768,
                    settings: {
                     slidesToShow: 3,
                     slidesToScroll: 3,
                   }
                   
                  },
                  {
                    breakpoint: 480,
                    settings: {
                     slidesToShow: 2,
                     slidesToScroll: 2,
                     
                   }
                   
                  }
                ]
               });             
        }
        if($('.extended-description tr th:contains("#top-vlastnosti")').length){
            $('.p-info-wrapper').append('<div class="topFeatures"><div class="topFeaturesProduct"></div><div class="AdmintopfeaturesProduct"></div></div>')
            var TopFeatures = $('.extended-description table tr:contains("#top-vlastnosti") td').text().split('|');
            TopFeatures.forEach(function(text) {
                var withoutdiacritics = text.replace('<br>', '').normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '-').toLowerCase();
                var imageRoad = '/user/documents/upload/obrazky/detail/topVlastnosti/'+withoutdiacritics+'.svg?v='+new Date().getMinutes()
                $('.topFeaturesProduct').append('<div class="' + withoutdiacritics.toLowerCase() + ' productTop"><div class="svgIcon"><img src="'+imageRoad+'" alt="'+text+'"></div><span class="text">'+text+'</span></div>');
                if($('.admin-logged').length){
                    $('.AdmintopfeaturesProduct').append('<div class="feature">Jméno vlastnosti: '+text.replace('<br>', '')+'<br>Název souboru: '+withoutdiacritics.toLowerCase()+'</div>')
                }
            });
            $('.extended-description table tr:contains("#top-vlastnosti")').remove()
        }
        if($('.extended-description tr th:contains("#složení")').length){
            $('#p-detail-tabs li').first().after('<li class="shp-tab" data-testid="tabIngredients" data-width=""><a href="#productIngredients" class="shp-tab-link" role="tab" data-toggle="tab">Složení</a></li>')
            $('#tab-content').append('<div id="productIngredients" class="tab-pane fade" role="tabpanel" data-testid="areaIngredients"><p>'+$('.extended-description tr th:contains("#složení")').closest('tr').find('td').html()+'</p></div>')
            $('.extended-description tr th:contains("#složení")').closest('tr').remove()
        }
        if($('.extended-description tr').length>1){
            $('#p-detail-tabs li').first().after('<li class="shp-tab" data-testid="tab" data-width=""><a href="#productParameters" class="shp-tab-link" role="tab" data-toggle="tab">Parametry</a></li>')
            $('#tab-content').append('<div id="productParameters" class="tab-pane fade" role="tabpanel" data-testid="areaParameters">'+$('.extended-description').html()+'</div>')
        }
    }
    if(!$('#simple-variants').length){
        if($('.variant-list, .surcharge-list').length>0){
            $('.variant-list select, .surcharge-list select').each(function(){
                if($(this).closest('.surcharge-list').find('th .show-tooltip').length){
                    var listTootip = $(this).closest('.surcharge-list').find('th .show-tooltip').attr('title')
                }
                else{
                    listTootip = ''
                }
                var optionLength = $(this).find('option').length
                var data_parameter_id = $(this).data('parameter-id')
                var html_var = '<div class="custom-variant" data-groupId="'+data_parameter_id+'"><div class="h3">'+$(this).attr('data-parameter-name')+'</div>'
                html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
                $(this).find('option').each(function(){
                    var data_value = $(this).attr('value')
                    if($(this).closest('td').find('select[name*="parameterValueId"]').length){
                        if ($.isNumeric($(this).val())) {
                            var textsplit = $(this).text().split('+')
                            html_var += '<div class="variant haveVariant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                            html_var += '<div class="text">'
                            if(typeof textsplit[1] === 'undefined'){
                                html_var += textsplit[0]
                            }
                            else{
                                html_var += textsplit[0]+' (+'+textsplit[1]+')'
                            }
                          
                            if(listTootip !== ''){
                                if(textsplit[1] !== '0 Kč'){
                                    html_var += '<span class="show-tooltip question-tooltip" title="'+listTootip+'">?</span>'
                                }
                            }
                            html_var += '</div>'
                            html_var += '</div>'
                        }
                    }
                    else{
                        if ($.isNumeric($(this).val())) {
                            var textsplit = $(this).text().split('+')
                            html_var += '<div class="variant haveSurcharge show-tooltip" title="'+$(this).text()+'" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                            html_var += '<div class="image"><img src="/user/documents/upload/obrazky/detail/priplatky/'+data_value+'.svg?v='+new Date().getMinutes()+'" alt="'+$(this).text()+'"></div>'
                            html_var += '</div>'
                        }
                    }
                    
                })
                html_var += '</div>'
                html_var += '</div>'
                $(this).after(html_var)
                $(this).closest('.variant-list select, .surcharge-list select').hide()
               $(this).closest('.variant-list span, .surcharge-list span').hide()
              
            })
    
            var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
            for (var parentKey in necessaryVariantData) {
                if (necessaryVariantData.hasOwnProperty(parentKey)) {
                    var variant = necessaryVariantData[parentKey];
                    console.log(variant)
                    $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').addClass('haveImage').attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-')).append('<div class="image"><img src="'+variant.variantImage.detail_small+'" alt="'+variant.name+'"></div>')
                
                }
            }
            
        }
    }
    

    $(document).on('click', '.custom-variant-wrap .variant', function(){
        const variantData = $(this).data('value');
        const variantParameterId = $(this).data('parameter-id');
    
        // Změna pro data-parameter-id 281 a třídu active
        if($(this).attr('data-parameter-id') === '281' && $(this).hasClass('active')){
            $("select[data-parameter-id='281'] option:first").prop("selected", true).change();
            $(this).removeClass("active"); 
        }
        else if($(this).attr('data-parameter-id') === '379' && $(this).hasClass('active')){
            $("select[data-parameter-id='379'] option:first").prop("selected", true).change();
            $(this).removeClass("active"); 
        } else {
            // Původní chování pro ostatní případy
            $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){
                return $(this).attr('value') == variantData;
            }).change().prop("selected", true);
            $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
            $(this).addClass("active"); 
        }
    
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change');
    
       // $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
       // $(this).addClass("active");    
    
        $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
    
        $('.custom-variant-wrap .variant').each(function(){
            const variantData = $(this).data('value');
            const variantParameterId = $(this).data('parameter-id');
            const unavailable = $("select[data-parameter-id='"+variantParameterId+"'] option[value='" + variantData + "']").hasClass("unavailable-option");
            if (unavailable === true) {
                $(this).addClass("unavailable").removeClass("active");
            }
            else{
                $(this).removeClass("unavailable");
            } 
        });
    });

    $(document).on('click', '#jsUnavailableCombinationMessage a', function(){
        $('.custom-variant-wrap .variant').removeClass('unavailable')
    })
    $(document).ready(function(){
        $('.custom-variant .variant[data-param-val="51-135"]').trigger('click');
        $(".custom-variant-wrap").each(function() {
            var $variants = $(this).find("div.variant");
            if ($variants.length === 1) {
             // $variants.addClass("active");
            }
          });
        var urlParams = new URLSearchParams(window.location.search);
        var parameterValueId = urlParams.get("parameterValueId");
        var $divToHighlight = $("div.variant[data-value='" + parameterValueId + "']");
        if ($divToHighlight.length > 0) {
            $divToHighlight.addClass("active");
        }
    })
    $(document).ready(function(){
        if($('.responsive-nav').length){
            if($('#p-detail-tabs').length){
                $('#p-detail-tabs').append($('.hidden-links').html())
            }
        }
    })
    
}